export default {
  selection: "Pemilihan Bahasa Sistem",
  english: "English",
  simplified_chinese: "中文 （简体）",
  list: {
    en: "Inggeris",
    zh: "Cina (CN)",
    tw: "Cina (TW)",
    vi: "Vietnam",
    th: "Thai",
    id: "Indonesia",
    malay: "Melayu",
    jp: "Jepun",
    kr: "Korea",
    my: "Myanmar",
    ar: "Argentina",
    ru: "Rusia",
    ne: "Nepal",
    bn: "Bangla"
  }
};
